import { createTheme } from "@mui/material/styles";
import { primaryColor, accentColor } from "./constants/consts";

export const theme = createTheme({
  palette: {
    primary: { main: primaryColor },
    secondary: { main: accentColor },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});
